<template>
  <content-container :overlay="loading" :container="false" no-bottom-margin class="fh-area fh-container justify-content-between">
    <b-container>
      <b-row class="mb-5" v-if="licenses && licenses.length">
        <b-col cols="12" sm="8" md="9" class="text-center text-md-left v-center">
          <template v-if="licenses && licenses.length">
            <!-- === Хотябы одна лицензия ======== -->
            <div class="mb-4 mb-sm-0 text-secondary">
              <template v-if="unpaidLicenses.length">
                {{ $tc('license.list.summary.active', activeLicenses.length) }},
                {{ $tc('license.list.summary.awaiting_payment', unpaidLicenses.length) }}
              </template>
              <template v-else>
                {{ $tc('license.list.summary.active', activeLicenses.length) }}.
              </template>
            </div>
          </template>
          <template v-else>
            <!-- === Лицензий нет, пусто! ======== -->
            <h5>{{ $tc('license.nolist.nothing') }}</h5>
            <p class="text-secondary">{{ $tc('license.nolist.quick') }}
              <a href="https://dbinvent.com/rdbm-best.html">{{ $tc('license.nolist.best') }}</a></p>
            <p class="text-secondary"> {{ $tc('license.nolist.download') }} <a
                href="https://dbinvent.com/products.html">rdbm</a>
            </p>
          </template>
        </b-col>
        <b-col cols="12" sm="4" md="3" class="text-center text-sm-right v-center">
          <div>
            <b-button variant="primary" @click="handleCreateClick('none')"
            >
              <b-icon-file-earmark-plus
                  aria-hidden="true"
                  class="mr-1"
              ></b-icon-file-earmark-plus
              >
              {{ $t('license.list.create') }}
            </b-button
            >
          </div>
        </b-col>
      </b-row>
      <b-row>
        <template v-if="licenses && licenses.length">
          <b-col cols="12">
            <template v-if="unpaidLicenses.length">
              <h5 class="mb-2rem">{{ $t('license.list.can_pay') }}</h5>
              <div class="packages">
                <license
                    v-for="item in unpaidLicenses"
                    :key="item.id"
                    :item="item"
                    :licenses="licenses"
                    :id="item.id"
                    @show-pay-dialog="showPayDialog"
                ></license>
              </div>
            </template>

            <template v-if="activeLicenses.length">
              <h5 class="mb-2rem">{{ $t('license.list.active') }}</h5>
              <div class="packages">
                <license
                    v-for="item in activeLicenses"
                    :key="item.id"
                    :item="item"
                    :licenses="licenses"
                    :id="item.id"
                ></license>
              </div>
            </template>

            <template v-if="suspendedLicenses.length">
              <h5 class="mb-2rem">{{ $t('license.list.archive') }}</h5>
              <div class="packages suspended">
                <license
                    v-for="item in suspendedLicenses"
                    :key="item.id"
                    :item="item"
                    :licenses="licenses"
                    :id="item.id"
                ></license>
              </div>
            </template>
          </b-col>
        </template>
        <template v-else>
          <b-col cols="12" id="no-licenses" class="pl-sm-0 pr-sm-0">
            <div class="text-center">
              <h2 class="mb-5">{{ $t('license.nolist.h') }}</h2>
              <h5 class="mb-5">
                <i18n path="license.nolist.intro" tag="label" for="articles.licensing-model">
                  <a :href="URL_LICENSING_MODEL" target="_blank">{{ $t('articles.licensing-model') }}</a>
                </i18n>
              </h5>
            </div>

            <b-row class="mb-5">
              <b-col cols="12" md="6" lg="4" class="d-md-flex d-lg-block">
                <div class="offer local-names">
                  <div class="product">
                    <div>
                      <h2>{{ $t('license.nolist.local.h') }}</h2>
                      <p class="description text-secondary">{{ $t('license.nolist.local.description') }}</p>
                    </div>
                    <div class="price">
                      <div><span class="tag small">$0</span> / {{ $t('license.nolist.local.for-individuals') }}</div>
                      <div><span class="alt-tag">$200</span> / {{ $t('license.nolist.local.for-business') }}</div>
                    </div>
                    <b-button variant="secondary" @click="handleCreateClick('locals')">{{ $t('license.nolist.local.action') }}</b-button>
                  </div>
                  <ul class="features">
                    <li v-html="$t('license.nolist.local.features.1')"></li>
                    <li v-html="$t('license.nolist.local.features.2')"></li>
                    <li class="text-secondary">{{ $t('license.nolist.local.features.3') }}</li>
                  </ul>
                </div>
              </b-col>
              <b-col cols="12" md="6" lg="4">
                <div class="offer standard box-shadow">
                  <div class="product">
                    <div>
                      <h2>{{ $t('license.nolist.standard.h') }}</h2>
                      <p class="description text-secondary">{{ $t('license.nolist.standard.description') }}</p>
                    </div>
                    <div class="price">
                      <div><span class="tag">{{ $t('license.nolist.standard.from') }} $200</span> / {{ $t('license.nolist.standard.period') }}</div>
                      <div class="text-secondary t90p">{{ $t('license.nolist.standard.taxes') }}</div>
                    </div>
                    <b-button variant="primary" @click="handleCreateClick('none')">{{ $t('license.nolist.standard.action') }}</b-button>
                  </div>
                  <ul class="features">
                    <li class="bright">{{ $t('license.nolist.standard.features.1') }}</li>
                    <li>{{ $t('license.nolist.standard.features.2') }}</li>
                    <li class="text-secondary">{{ $t('license.nolist.standard.features.3') }}</li>
                  </ul>
                </div>
              </b-col>
              <b-col cols="12" lg="4">
                <div class="offer enterprise">
                  <div class="product pb-md-0 pb-lg-4">
                    <div>
                      <h2>{{ $t('license.nolist.enterprise.h') }}</h2>
                      <p class="description text-secondary">{{ $t('license.nolist.enterprise.description') }}</p>
                    </div>
                    <b-row>
                      <b-col cols="12" md="6" lg="12">
                        <div class="price">
                          <div><span class="tag">$480</span> / {{ $t('license.nolist.standard.period') }}</div>
                          <div class="text-secondary t90p">{{ $t('license.nolist.standard.taxes') }}</div>
                        </div>
                      </b-col>
                      <b-col cols="12" md="6" lg="12" class="d-flex flex-column">
                        <b-button class="mt-md-2 mt-lg-0" @click="handleCreateClick('enterprise')" variant="primary">{{ $t('license.nolist.enterprise.action') }}</b-button>
                      </b-col>
                    </b-row>
                  </div>
                  <ul class="features">
                    <li class="bright">{{ $t('license.nolist.enterprise.features.1') }}</li>
                  </ul>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </template>
      </b-row>
    </b-container>
    <b-container fluid class="pl-0 pr-0">
      <section class="dark">
        <b-container>
          <b-row>
            <b-col>
              <p>
                <i18n path="license.nolist.other.quick-start" tag="label" for="articles.quick-start">
                  <a :href="URL_QUICK_START_GUIDE" target="_blank">{{ $t('articles.quick-start') }}</a>
                </i18n>
              </p>

              <p>
                <i18n path="license.nolist.other.download" tag="label" for="articles.here">
                  <a :href="URL_SETUP_DOWNLOAD" target="_blank">{{ $t('articles.here') }}</a>
                </i18n>
              </p>

              <div>
                <i18n path="license.nolist.other.contact-us" tag="label" for="articles.contact-us" class="mb-0">
                  <a :href="URL_SUPPORT_QUESTION" target="_blank">{{ $t('articles.contact-us') }}</a>
                </i18n>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </section>
    </b-container>

    <pay-license-modal
        ref="payModal"
    ></pay-license-modal>
  </content-container>
</template>

<script>
import ContentContainer from "@/components/ContentContainer";
import {BIconFileEarmarkPlus} from "bootstrap-vue";
import License from "../../rdbm/License.vue";
import PayLicenseModal from "./PayLicenseModal.vue";
import {
  licenseObject,
  EMPTY_COUNTER,
  EMPTY_SUMMARY,
  UNSAVED_LICENSE_ID,
  getUnpaid,
  getActive,
  getArchive,
  isConPaid
} from "@/components/rdbm/license.js";
import {
  URL_LICENSING_MODEL,
  URL_LOAD_LICENSE,
  URL_QUICK_START_GUIDE,
  URL_SETUP_DOWNLOAD,
  URL_SUPPORT_QUESTION
} from "@/globals";


const EMPTY_PRICE = {
  // Уже оплаченные, здесь смысл "сколько тебе эта лицензия уже стоит"
  paid: 0,
  // Не оплаченные, смысл "сколько накидал поверх уже оплаченного, если уже платил"
  unpaid: 0,
  // Итого: оплаченного и не оплаченного
  summary: 0,
};

export default {
  name: "UserRDBMLicenseList",
  props: ["message"],
  components: {
    ContentContainer,
    License,
    BIconFileEarmarkPlus,
    PayLicenseModal
  },
  data() {
    return {
      loading: false,
      licenses: [],
    };
  },
  methods: {
    showPayDialog: function (item) {
      this.$refs.payModal.execute(item);
    },
    handleCreateClick: function (special = null) {
      let special_type = special ? { type: special, individual: this.$store.state.user.client.is_individual } : null;

      this.$router.push({
        name: "rdbmItem",
        params: {
          id: UNSAVED_LICENSE_ID + licenseObject.lastId(),
          special: special_type
        },
      });
    },
    // Добавляет структуру со стоимостью лицензии
    // ToDo Здесь надо сделать вывод так, чтобы выводилась оплаченная цена и цена за неоплаченные имена
    _inject_price: function (list) {
      // Для каждой лицензии
      for (const license of list) {
        let summary = Object.assign({}, EMPTY_SUMMARY);
        license._price = Object.assign({}, EMPTY_PRICE);

        // Для каждого слота считается его стоимость
        for (let conn of license.connections) {
          let counter = Object.assign({}, EMPTY_COUNTER);
          licenseObject._count_types(conn, counter);
          licenseObject._make_summary(counter, summary, license.package);

          // Разделяем оплаченное от не оплаченного
          if (isConPaid(conn)) {
            license._price.paid += summary.price
          } else {
            license._price.unpaid += summary.price
          }
          license._price.summary += summary.price;
        }
      }
      return list;
    },
    dev_create_api: function (personal) {
      this.$post(
          "/api/dev/license",
          personal
              ? {
                personal,
                encrypt: true,
                email: this.$store.state.user.emails[0].email,
                hosts: [],
                db_names: [],
              }
              : {
                personal,
                encrypt: true,
                email: this.$store.state.user.emails[0].email,
                hosts: ["host_1", "host_2"],
                db_names: ["db_1", "db_2"],
              },
          true
      )
          .then(() => {
            this.load();
          })
          .catch((error) => {
            this.$alert.show(error);
          });
    },
    dev_create_test_data_set: function () {
      this.$get("/api/dev/license/test_data_set", true, true, true)
          .then((result) => {
            this.licenses = this._inject_price(result);
          })
          .catch((e) => {
            this.$alert.show(e);
          });
    },
    dev_create_delete_all: function () {
      this.$http_delete("/api/dev/license/all", true, true, true)
          .then(() => {
            this.licenses = [];
          })
          .catch((e) => {
            this.$alert.show(e);
          });
    },
    load: function () {
      this.$get(URL_LOAD_LICENSE, true, true, true)
          .then((result) => {
            this.licenses = this._inject_price(result);
          })
          .catch((e) => {
            this.$alert.show(e);
          });
    },
  },
  computed: {
    // Хотя бы что-то не оплачено
    unpaidLicenses: function () {
      return getUnpaid(this.licenses);
    },
    activeLicenses: function () {
      return getActive(this.licenses);
    },
    // Все внутри приостановленно
    suspendedLicenses: function () {
      return getArchive(this.licenses);
    },

    dev_visible: {
      get() {
        return this.$store.state.dev.visible;
      },
      set(value) {
        this.$store.commit("setVisible", value);
      },
    },
    dev_multi_service: {
      get() {
        return this.$store.state.dev.multi_service;
      },
      set(value) {
        this.$store.commit("setMultiService", value);
      },
    },
  },
  created() {
    this.URL_LICENSING_MODEL = URL_LICENSING_MODEL;
    this.URL_QUICK_START_GUIDE = URL_QUICK_START_GUIDE;
    this.URL_SETUP_DOWNLOAD = URL_SETUP_DOWNLOAD;
    this.URL_SUPPORT_QUESTION = URL_SUPPORT_QUESTION;
    this.load();
  },
};
</script>

<style>
.vh50 {
  min-height: 50vh;
}

.packages {
  margin-bottom: 2rem;
}

#no-licenses h5 {
  line-height: 1.5;
}

.offer {
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid #dfdfdf;
  padding: 1.25rem;
  margin-bottom: 2rem;
}

.offer[class*="local-names"] h2 {
  opacity: 0.75;
}

.offer[class*="standard"] h2 {
  color: var(--primary);
}

.offer[class*="enterprise"] h2 {
  color: var(--primary);
}

.box-shadow {
  border-radius: 8px;
  box-shadow: 0 0 8px -2px rgba(0, 0, 0, 0.1), 0 6px 20px -3px rgba(0, 0, 0, 0.2);
}

.product {
  display: flex;
  flex-direction: column;
  padding-bottom: 1.5rem;
  margin-bottom: 2rem;
  border-bottom: 1px solid #eae7e9;
}

.product .description {
  margin: 0;
  min-height: 5.5rem;
}

@media screen and (max-width: 992px) {
  .product .description {
    min-height: 5rem;
  }

  .offer[class*="enterprise"] .description {
    min-height: 3.5rem;
  }
}

@media screen and (max-width: 768px) {
  .product .description {
    min-height: 3.5rem;
  }
}

.product h2 {
  margin-bottom: 1.3rem;
}

.product .price {
  min-height: 5rem;
}

.product .price .tag {
  font-weight: bold;
  font-size: 1.6rem;
}

.product .price .tag.small {
  font-size: 1.4rem;
}

.product .price .alt-tag {
  font-weight: bold;
  color: #424242;
}

.features {
  margin: 28px 0 0;
  padding: 0 0 0 28px;
  background: white;
  max-width: none;
  border: 0;
  display: flex;
  flex-direction: column;
}

.features li {
  line-height: 1.5em;
  margin-bottom: 1rem;
  list-style: none;
  position: relative;
  padding-right: 24px;
}

.features li:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: -32px;
  top: 2px;
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAeklEQVQ4je3SwQmEMBCFYUtICVaw83iyvDlaih1ZgiWlBEvYErIHEQJ6UBPwkv80p29gmK5rtU4DfbJBEfC+HIOPRv2MSh9qLsS+eIyBPgEI1TCj0nYnBMB7o1ajklFLvugaCAQbFHc0n29jp2gpdkBrYDla5d9a7/UH+lI0zcwzVrcAAAAASUVORK5CYII=");
}

.features li[class^="bright"]:before {
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAeklEQVQ4je3SsQ2DMBCFYUbwCCcf6TNCRmEjSksvhUfyCBkhI/xUSBaigNhSGv/VVd9rbppGo9NcLFEUS1gzNideLr4umN+sTdhDPH/GXCyWCd0wF0RRLBMsYS4+LnCR66FLWSZEUXa0vm9jZ2gzdkS7YDXa5d9G/2sDVutpjjl+whoAAAAASUVORK5CYII=");
}
</style>
